/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D1dInputs */

const en_mk_sol_startup_d1d = /** @type {(inputs: Mk_Sol_Startup_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“What three things need my decision today?” is answered from the workspace itself — stalled issues, waiting approvals.`)
};

const id_mk_sol_startup_d1d = /** @type {(inputs: Mk_Sol_Startup_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Apa tiga hal yang perlu keputusanku hari ini?" dijawab dari isi workspace sendiri — issue yang macet, approval yang menunggu.`)
};

/**
* | output |
* | --- |
* | "“What three things need my decision today?” is answered from the workspace itself — stalled issues, waiting approvals." |
*
* @param {Mk_Sol_Startup_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d1d = /** @type {((inputs?: Mk_Sol_Startup_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d1d(inputs)
	return en_mk_sol_startup_d1d(inputs)
});